import { useCallback } from 'react';

import { useTelemetry } from '@order/Telemetry';

// ─────────────────────────────────────────────────────────────────────────────

export const useChallengeCelebrationTelemetry = () => {
  const { track } = useTelemetry();

  // ─────────────────────────────────────────────────────────────────────

  const trackNavigateToLoyaltyTab = useCallback(() => {
    track('challenges.my_rewards');
  }, [track]);

  const trackCelebrationModalShow = useCallback(
    (details: CelebrationDetails) => {
      const { celebrationCopy, challengesIds, expirationDate, title } = details;

      track('challenges.completed', {
        celebrationCopy,
        challengesIds,
        expirationDate: expirationDate ?? undefined,
        title,
      });
    },
    [track],
  );

  const trackCelebrationModalDismiss = useCallback(() => {
    track('challenges.closed');
  }, [track]);

  // ─────────────────────────────────────────────────────────────────────

  return {
    trackNavigateToLoyaltyTab,
    trackCelebrationModalShow,
    trackCelebrationModalDismiss,
  };
};

// ─── Types ───────────────────────────────────────────────────────────────────

type CelebrationDetails = {
  celebrationCopy: string;
  challengesIds: readonly string[];
  expirationDate?: string | null;
  title: string;
};
